<template>
    <div class="Emp">
        <div class="fotoFull"> <!-- OPEN CARD EMPILHADEIRAS -->
            <mq-layout :mq="['xs', 'sm']">
                <img
                    src="../../assets/empilhadeiras_CARD_SMALL.jpg"
                    alt="EMPILHADEIRAS ELÉTRICAS"
                    class="fotoFullSMALL"
                />
            </mq-layout>
                <mq-layout mq="md+">
                <img
                    src="../../assets/empilhadeiras_CARD.jpg"
                    alt="EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV OPEN CARD EMPILHADEIRAS -->

        <div class="paiVantagensEmp">
            <div class="backgroundVantagensEmp">
                <mq-layout mq="md+">
                    <div class="efeitoLogoPortifolioSolucoesTecnologia1">
                        <HionEffect class="HionEffectLithiumSolucoesTecnologia1" :configHionEffect="configHionEffectPortifolioEmp2" />
                    </div>
                    <div class="efeitoLogoPortifolioSolucoesTecnologia2">
                        <HionEffect class="HionEffectLithiumSolucoesTecnologia2" :configHionEffect="configHionEffectPortifolioEmp2" />
                    </div>
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia4" id="linhaDirAppEmp4">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp2" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia5" id="linhaDirAppEmp5">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia6" id="linhaDirAppEmp6">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                </div>
                </mq-layout>
                <div class="efeitoLinhaLithiumSolucoesTecnologia1">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp2" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia2">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia3">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                </div>
                
                <div class="efeitoAneisPortifolioSolucoesTecnologia1">
                    <AneisEffect :configAneis="configAneisPortifolioEmp2" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia2">
                    <AneisEffect :configAneis="configAneisPortifolioEmp2" />
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia1">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioEmp2"/>
                </div>
            </div> <!-- FINAL DIV BACKGROUND -->

            <div class="frontendVantagensEmp">
                
                <div class="tituloVantagensEmp">VANTAGENS</div>
                <div class="subTituloVantagensEmp1"><strong>SEGURANÇA</strong><br>NA OPERAÇÃO</div>
                <div class="subTituloVantagensEmp2">RECARGA ULTRA<br><strong>RÁPIDA</strong></div>
                <div class="iconeVantagensEmp1"><i class="fas fa-user-shield"></i></div>
                <div class="iconeVantagensEmp2"><i class="far fa-clock"></i></div>
                <div class="faixaVantagensEmp">
                    <div class="textofaixaVantagensEmp">60% maior autonomia<br>3x mais vida útil</div>
                    <div class="iconefaixaVantagensEmp"><i class="fas fa-thumbs-up"></i></div>
                </div>
                <div class="textoVantagensEmp">
                    +5000 ciclos (+80% DoD)<br><br>
                    Sua equipe de operadores pode<br>
                    simplesmente conectar o carregador<br>
                    durante os intervalos e depois voltar<br>
                    ao trabalho. Não há mais salas de<br> 
                    bateria, nem é necessária ventilação<br>
                    durante o processo de carregamento.
                </div>

            </div> <!-- Final DIV FRONTEND -->

        </div> <!-- Final DIV  VANTAGENS -->

        <div class="fotoFull"> <!-- FOTO CARD APLICACOES -->
            <mq-layout :mq="['xs', 'sm']">
                <img
                    src="../../assets/aplicacoes_empilhadeiras_SMALL.jpg"
                    alt="APRESENTAÇÃO - APLICAÇÕES EMPILHADEIRAS ELÉTRICAS"
                    class="fotoFullSMALL"
                />
            </mq-layout>
            <mq-layout mq="md+">
                <img
                    src="../../assets/aplicacoes_empilhadeiras.jpg"
                    alt="APRESENTAÇÃO - APLICAÇÕES EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV FOTO APLICAÇÕES EMPILHADEIRAS -->
    
        <div class="paiAplicacoesEmp">
            <div class="backgroundAplicacoesEmp">
                <div class="efeitoLogoPortifolioSolucoesTecnologia1">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia1" :configHionEffect="configHionEffectPortifolioEmp" />
                </div>
                <div class="efeitoLogoPortifolioSolucoesTecnologia2">
                    <HionEffect class="HionEffectLithiumSolucoesTecnologia2" :configHionEffect="configHionEffectPortifolioEmp" />
                </div>

                <div class="efeitoLinhaLithiumSolucoesTecnologia1">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia2">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY" />
                </div>
                <div class="efeitoLinhaLithiumSolucoesTecnologia3">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia4" id="linhaDirAppEmp4">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia5" id="linhaDirAppEmp5">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY" />
                </div>
                <div class="efeitoLinhaPortifolioSolucoesTecnologia6" id="linhaDirAppEmp6">
                    <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY" />
                </div>
                
                <div class="efeitoAneisPortifolioSolucoesTecnologia1">
                    <AneisEffect :configAneis="configAneisPortifolioEmp" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia2">
                    <AneisEffect :configAneis="configAneisPortifolioEmp" />
                </div>

                <mq-layout :mq="['xs', 'sm','md']">
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia8">
                        <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp" />
                    </div>
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia9">
                        <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp" />
                    </div>
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia10">
                        <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp" />
                    </div>
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia11">
                        <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY" />
                    </div>
                    
                    <div class="efeitoAneisPortifolioSolucoesTecnologia8">
                        <AneisEffect :configAneis="configAneisPortifolioEmp" />
                    </div>
                    <div class="efeitoAneisPortifolioSolucoesTecnologia4">
                        <AneisEffect :configAneis="configAneisPortifolioEmp" />
                    </div>
                    <div class="efeitoAneisPortifolioSolucoesTecnologia5">
                        <AneisEffect :configAneis="configAneisPortifolioEmp" />
                    </div>
                    <div class="efeitoAneisPortifolioSolucoesTecnologia6">
                        <AneisEffect :configAneis="configAneisPortifolioEmp" />
                    </div>

                    <div class="efeitoArgolasPortifolioSolucoesTecnologia2">
                        <ArgolasEffect :configArgolas="configArgolasPortifolioEmp"/>
                    </div>
                    <div class="efeitoArgolasPortifolioSolucoesTecnologia4">
                        <ArgolasEffect :configArgolas="configArgolasPortifolioEmp"/>
                    </div>
                    <div class="efeitoArgolasPortifolioSolucoesTecnologia6">
                        <ArgolasEffect :configArgolas="configArgolasPortifolioEmp"/>
                    </div>
                </mq-layout>

            </div><!-- Final DIV BACKGROUND AplicacoesEmp -->

            <div class="frontendAplicacoesEmp">
                <div class="tituloPortifolioSolucoesTecnologia">APLICAÇÕES</div>
                <mq-layout :mq="['xs', 'sm', 'md']">
                    <img
                        src="../../assets/foto_aplicacoes_empilhadeiras_SMALL.jpg"
                        alt="APLICAÇÕES EMPILHADEIRAS ELÉTRICAS"
                        class="fotoFullSMALL"
                    />
                </mq-layout>
                <mq-layout mq="lg+">
                    <img
                        src="../../assets/foto_aplicacoes_empilhadeiras.jpg"
                        alt="APLICAÇÕES EMPILHADEIRAS ELÉTRICAS"
                        class="fotoWIDEcard"
                    />
                </mq-layout>
            </div> <!-- Final DIV FRONTEEND AplicacoesEmp -->

        </div> <!-- Final DIV AplicacoesEmp -->

        <div class="paiEcoEmp">
            <div class="backgroundEcoEmp">
                <mq-layout :mq="['xs', 'sm', 'md']">
                    <img
                        src="../../assets/BACKGROUND_ECO_EMP_SMALL.jpg"
                        alt="APLICAÇÕES EMPILHADEIRAS ELÉTRICAS"
                        class="FullCardEmp"
                    />
                </mq-layout>
                <mq-layout mq="lg">
                    <img
                        src="../../assets/BACKGROUND_ECO_EMP_LG.jpg"
                        alt="APLICAÇÕES EMPILHADEIRAS ELÉTRICAS"
                        class="FullCardEmp"
                    />
                </mq-layout>
                <mq-layout mq="xl">
                    <img
                        src="../../assets/BACKGROUND_ECO_EMP.jpg"
                        alt="APLICAÇÕES EMPILHADEIRAS ELÉTRICAS"
                        class="FullCardEmp"
                    />
                </mq-layout>
            </div> <!-- FINAL DIV BACKGROUND -->    

            <div class="frontendEcoEmp">
                
                <div class="subTituloEcoEmp1"><strong>ECOLÓGICA</strong><br>E COM <strong>MENOR CUSTO</strong><br>OPERACIONAL</div>
                <div class="subTituloEcoEmp2"><strong>MANUTENÇÕES</strong> DE <strong>TROCA</strong><br> DE <strong>ÁCIDO NUNCA MAIS</strong>!</div>
                <div class="iconeEcoEmp1"><i class="fas fa-leaf"></i></div>
                <div class="textoEcoEmp1">
                    Sem ácidos tóxicos, sem corrosão, sulfatação,<br>
                    contaminação e efeito memória.<br>
                    Não liberam gases explosivos durante<br>
                    o carregamento.
                </div>
                <div class="textoEcoEmp2">
                    Suas operações podem ser realizadas<br>
                    sem que precise gerenciar os<br>
                    cronogramas de manutenção de bateria.<br>
                    Isso além de economia de tempo,<br>
                    permite que os operadores se concentrem<br>
                    apenas em mover os produtos dentro da<br>
                    fábrica, galpão ou armazém.
                </div>
           
            </div><!-- Final DIV FRONTEND -->

        </div> <!-- Final DIV  paiEcosEmp -->

        <div class="paiVsEmp">
            <div class="backgroundVsEmp">
                <div class="efeitoLinhaLithiumSolucoesTecnologia1">
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp2" />
                </div>
                <div class="efeitoAneisPortifolioSolucoesTecnologia2">
                    <AneisEffect :configAneis="configAneisPortifolioEmp2" />
                </div>
                <div class="efeitoArgolasPortifolioSolucoesTecnologia1">
                    <ArgolasEffect :configArgolas="configArgolasPortifolioEmp2"/>
                </div>

                <mq-layout mq="lg+">
                    <div class="efeitoLogoPortifolioSolucoesTecnologia1">
                        <HionEffect class="HionEffectLithiumSolucoesTecnologia1" :configHionEffect="configHionEffectPortifolioEmp2" />
                    </div>
                    <div class="efeitoLogoPortifolioSolucoesTecnologia2">
                        <HionEffect class="HionEffectLithiumSolucoesTecnologia2" :configHionEffect="configHionEffectPortifolioEmp2" />
                    </div>
                    <div class="efeitoLinhaLithiumSolucoesTecnologia2">
                        <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                    </div>
                    <div class="efeitoLinhaLithiumSolucoesTecnologia3">
                        <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                    </div>
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia4" id="linhaDirAppEmp4">
                        <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp2" />
                    </div>
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia5" id="linhaDirAppEmp5">
                        <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                    </div>
                    <div class="efeitoLinhaPortifolioSolucoesTecnologia6" id="linhaDirAppEmp6">
                        <LinhaHorizontalY :configLinhasY="configLinhasPortifolioEmpY2" />
                    </div>
                    <div class="efeitoAneisPortifolioSolucoesTecnologia1">
                        <AneisEffect :configAneis="configAneisPortifolioEmp2" />
                    </div>
                </mq-layout>

            </div> <!-- FINAL DIV BACKGROUND -->

            <div class="frontendVsEmp">
                
                <div class="tituloVsEmp1">BATERIA<br><strong>CHUMBO-ÁCIDO</strong></div>
                <div class="tituloVsEmp2">BATERIA<br><strong>INTELIGENTE HION</strong></div>
                <div class="subTituloVsEmp1">TEMPO PARA RECARGA</div>
                <div class="subTituloVsEmp2">TEMPO PARA RECARGA</div>
                <div class="iconeVsEmp1">
                    <img
                        src="../../assets/icone_versus.png"
                        alt="VERSUS"
                        class="OpenCardBms"
                    />
                </div>icone_versus
                <div class="iconeVsEmp2"><i class="fas fa-plug"></i></div>
                <div class="faixaVsEmp1">
                    <div class="textofaixaVsEmp1">7 HORAS</div>
                </div>
                <div class="faixaVsEmp2">
                    <div class="textofaixaVsEmp2">50 MINUTOS</div>
                </div>
                <div class="textoVsEmp1">
                    Potência e autonomia limitada;<br><br>
                    Menor capacidade de <br>armazenamento de energia;<br><br>
                    Uma bateria por turno de trabalho;<br><br>
                    De 2 a 5 anos de vida útil;
                </div>
                <div class="textoVsEmp2">
                    Maior durabilidade e autonomia;<br><br>
                    60% maior capacidade de<br>armazenamento de energia;<br><br>
                    Uma bateria por empilhadeiras nos 3 turnos;<br><br>
                    De 10 a 15 anos de vida útil;
                </div>

            </div> <!-- Final DIV FRONTEND -->

        </div> <!-- Final DIV  VERSUS -->

        <div class="fotoFull"> <!-- FOTO CARD OPERAÇÕES EFICIENTES -->
            <mq-layout :mq="['xs', 'sm', 'md']">
                <img
                    src="../../assets/empilhadeiras_pag4_SMALL.jpeg"
                    alt="OPERAÇÕES EFICIENTES - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
            <mq-layout mq="lg+">
                <img
                    src="../../assets/empilhadeiras_pag4.jpg"
                    alt="OPERAÇÕES EFICIENTES - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV FOTO OPERAÇÕES EFICIENTES -->

        <div class="fotoFull"> <!-- FOTO CARD EFICIENCIA ENERGÉTICA -->
            <mq-layout :mq="['xs', 'sm', 'md']">
                <img
                    src="../../assets/empilhadeiras_pag7_SMALL.jpeg"
                    alt="EFICIENCIA ENERGÉTICA - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
            <mq-layout mq="lg+">
                <img
                    src="../../assets/empilhadeiras_pag7.jpg"
                    alt="EFICIENCIA ENERGÉTICA - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV FOTO EFICIENCIA ENERGÉTICA -->

        <div class="fotoFull"> <!-- FOTO CARD COMO FUNCIONA -->
            <mq-layout :mq="['xs', 'sm', 'md']">
                <img
                    src="../../assets/empilhadeiras_pag6_SMALL.jpeg"
                    alt="COMO FUNCIONA - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
            <mq-layout mq="lg+">
                <img
                    src="../../assets/empilhadeiras_pag6.jpg"
                    alt="COMO FUNCIONA - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV FOTO COMO FUNCIONA -->

        <div class="fotoFull"> <!-- FOTO CARD REDUZ CUSTOS OPERACIONAIS -->
            <mq-layout :mq="['xs', 'sm', 'md']">
                <img
                    src="../../assets/empilhadeiras_pag8_SMALL.jpeg"
                    alt="REDUZ CUSTOS OPERACIONAIS- EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
            <mq-layout mq="lg+">
                <img
                    src="../../assets/empilhadeiras_pag8.jpg"
                    alt="REDUZ CUSTOS OPERACIONAIS - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV FOTO REDUZ CUSTOS OPERACIONAIS -->

        <div class="fotoFull"> <!-- FOTO CARD COMPARAÇÃO ENTRE OPERAÇÕES -->
           <!--<mq-layout :mq="['xs', 'sm', 'md']">
                <img
                    src="../../assets/empilhadeiras_pag9_SMALL.jpg"
                    alt="COMPARAÇÃO ENTRE OPERAÇÕES - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>-->
            <mq-layout mq="md+">
                <img
                    src="../../assets/empilhadeiras_pag9.jpg"
                    alt="COMPARAÇÃO ENTRE OPERAÇÕES - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV FOTO COMPARAÇÃO ENTRE OPERAÇÕES -->

        <div class="fotoFull"> <!-- FOTO CARD HION TECNOLOGIA -->
            <!--<mq-layout :mq="['xs', 'sm', 'md']">
                <img
                    src="../../assets/empilhadeiras_pag10_SMALL.jpg"
                    alt="HION TECNOLOGIA - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>-->
            <mq-layout mq="md+">
                <img
                    src="../../assets/empilhadeiras_pag10.jpg"
                    alt="HION TECNOLOGIA - EMPILHADEIRAS ELÉTRICAS"
                    class="OpenCardBms"
                />
            </mq-layout>
        </div> <!-- Final da DIV FOTO HION TECNOLOGIA -->

        <div class="contatoHome"> <!-- CARD CONTATOS EMPILHAEIRAS -->
            <div class="backgroundContatoHome">
                <mq-layout mq="md+">
                    <div class="efeitoLogoContatoHome1">
                        <HionEffect class="HionEffectHomeContato1" :configHionEffect="configHionEffectPortifolioEmp" />
                    </div>
                    <div class="efeitoLogoContatoHome2">                 
                        <HionEffect class="HionEffectHomeContato2" :configHionEffect="configHionEffectPortifolioEmp" />
                    </div>
                    <LinhaHorizontal :configLinhas="configLinhasPortifolioEmp" class="efeitoLinhaContatoHome" />
                </mq-layout>
                <mq-layout :mq="['xs', 'sm']">
                    <div class="efeitoLogoContatoHomeSmall">
                        <HionEffect class="HionEffectHomeContatoSmall" :configHionEffect="configHionEffectHomeContatoSmall" />
                    </div>
                </mq-layout>
            </div>
            <div class="frontendContatotHome">

                    <div class="tituloContatoHome">Gostaria de reduzir até 77% dos custos de sua operação?<br>Fale com a gente!</div>

                <div class="formContatoHome">
                    <b-form @submit="SubmitFormEmp">
                        <b-form-group id="FormGrupoEmail">
                            <b-form-input
                            id="input-Email-Contato"
                            v-model="formEmp.email"
                            type="email"
                            required
                            placeholder="seuemail@gmail.com"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group id="FormGrupoMensagem">
                            <b-form-input
                            id="input-Mensagem-Contato"
                            v-model="formEmp.mensagem"
                            required
                            placeholder="Mensagem"
                            ></b-form-input>
                        </b-form-group>

                        <b-button type="submit" class="botaoFormContato">Enviar</b-button>
                    </b-form>
                </div>
            </div>
        </div> <!-- FINAL FIV CONTATOS EMPILHADEIRAS -->

        <div class="newsletterHome"> <!-- CARD NEWSLETTER -->
            <b-container fluid class="containerNewsletter">
                <b-row align-v="center" class="rowNewsletter">
                    <b-col cols="12" md="6" align-self="center" class="text-center textoNewsletterHome">
                        Fique por dentro de nossas novidades. Inscreva-se
                    </b-col>
                    <b-col cols="12" md="6" align-self="center" class="text-center inputNewsletterHome">
                        <b-form @submit="SubmitFormNewsletterEmp">
                            <b-form-group id="FormGrupoNewsletter">
                                <b-form-input
                                id="input-Email-Newsletter"
                                v-model="newsletterEmp.email"
                                type="email"
                                required
                                placeholder="seuemail@gmail.com"
                                v-on:keyup.enter="submit"
                                ></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </b-container>
        </div><!-- FINAL CARD NEWSLETTER -->

    </div> <!-- FINAL DA DIV Emp -->
</template>

<script>
import HionEffect from '../efeitos/hion_globo'
import LinhaHorizontal from '../efeitos/LinhaHorizontal'
import LinhaHorizontalY from '../efeitos/LinhaHorizontalY'
import ArgolasEffect from '../efeitos/Argolas'
import AneisEffect from '../efeitos/Aneis'

export default {
    name: 'Empilhadeiras',
    components: { HionEffect, LinhaHorizontal, ArgolasEffect, AneisEffect, LinhaHorizontalY },
    data() {
        return {
            configLinhasPortifolioEmp: {
                backgroundLinhas: "#fff",
                CorLinhas: "#008fac"
            },
            configLinhasPortifolioEmpY: {
                backgroundLinhasY: "#fff",
                CorLinhasY: "#008fac"
            },
            configHionEffectPortifolioEmp: {
                backgroundHionEffect: "#fff",
                CorHionEffect:"#008fac",
            },
            configAneisPortifolioEmp: {
                backgroundAneis: "#fff",
                CorAneis: "#008fac",
            },
            configArgolasPortifolioEmp: {
                backgroundArgolas: "#fff",
                CorArgola: "#008fac",
            },
            configLinhasPortifolioEmp2: {
                backgroundLinhas: "#eee",
                CorLinhas: "#008fac"
            },
            configLinhasPortifolioEmpY2: {
                backgroundLinhasY: "#eee",
                CorLinhasY: "#008fac"
            },
            configHionEffectPortifolioEmp2: {
                backgroundHionEffect: "#eee",
                CorHionEffect:"#008fac",
            },
            configAneisPortifolioEmp2: {
                backgroundAneis: "#eee",
                CorAneis: "#008fac",
            },
            configArgolasPortifolioEmp2: {
                backgroundArgolas: "#eee",
                CorArgola: "#008fac",
            },
            configHionEffectHomeContatoSmall: {
                backgroundHionEffect: "#000",
                CorHionEffect:"#008fac",
            },
            formEmp: {
                email: '',
                mensagem: ''
            },
            newsletterEmp: {
                email: ''
            }
        }
    },
    methods: {
        SubmitFormEmp(evt) {
            evt.preventDefault()
            alert('Empilhadeiras ' + JSON.stringify(this.formEmp))
        },
        SubmitFormNewsletterEmp(evt) {
            evt.preventDefault()
            alert('Cadastro Realizado com Sucesso - '+ JSON.stringify(this.newsletter))
        },
    }
}
</script>

<style>
.Emp {
    position: relative;
    background:#fff;
    color: #2e2d2c;
    height: 100%;
    width: 100%;
    min-height: 500px;
}
.fotoFull {
    position: relative;
    width: 100%;
    text-align: center;
    overflow: hidden;
}
.fotoWIDEcard {
    position: relative;
    width: 100%;
    max-height: 700px;
    text-align: center;
    overflow: hidden;
}
.fotoFullSMALL {
    position: relative;
    width: 100%;
    text-align: center;
    overflow: hidden;
}

/* Inicio CSS VANTAGENS Empilhadeiras ****************/
.paiVantagensEmp {
    position: relative;
    height: 800px;
    width: 100%;
    background: #eee;
    overflow: hidden;
}

.frontendVantagensEmp {
    width: 100%;
}
.tituloVantagensEmp {
    position: absolute;
    font-size: 4em;
    font-family: 'Raleway';
    /*font-weight:lighter;*/
    color: #2e2d2c;
    top: 150px;
    left: 150px;
}
.textoVantagensEmp {
    position: absolute;
    font-size: 1.3em;
    font-family:'Raleway';
    /*font-weight:lighter;*/
    color: #2e2d2c;
    top: 400px;
    left: calc(50% + 100px);
}
.subTituloVantagensEmp1 {
    position: absolute;
    font-size: 3em;
    font-family: 'Raleway';
    line-height: 1.1;
    color: #2e2d2c;
    top: 330px;
    left: 250px;
}
.subTituloVantagensEmp2 {
    position: absolute;
    font-size: 3em;
    font-family: 'Raleway';
    line-height: 1.1;
    color: #2e2d2c;
    top: 250px;
    left: calc(50% + 100px);
}
.iconeVantagensEmp1 {
    position: absolute;
    font-size: 4.5em;
    color: #2e2d2c;
    top: 320px;
    left: 150px;
}
.iconeVantagensEmp2 {
    position: absolute;
    font-size: 4.5em;
    color: #2e2d2c;
    top: 250px;
    left: calc(50% + 10px);
}
.faixaVantagensEmp {
    position: absolute;
    width: 450px;
    height: 100px;
    top: 600px;
    left: 3px;
    background-color: #ffd618;
    border-bottom-right-radius: 30px;
}
.iconefaixaVantagensEmp {
    position: absolute;
    font-size: 4em;
    color: #2e2d2c;
    top: 0px;
    left: 50px;
}
.textofaixaVantagensEmp {
    position: absolute;
    font-size: 1.3em;
    font-family: 'Raleway';
    font-weight:bold;
    color: #2e2d2c;
    top: 20px;
    left: 150px;
}

/* CSS do APLICACOES EMPILHADEIRAS **********************************/
.paiAplicacoesEmp {
    position: relative;
    width: 100%;
    height: 900px;
    overflow:hidden;
}
.frontendAplicacoesEmp {
    position: absolute;
    width: 100%;
    z-index: 3;
    padding: 50px 50px 50px 50px;
}
.backgroundAplicacoesEmp {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 4;
}
#linhaDirAppEmp4 {
    top: 700px;
}
#linhaDirAppEmp5 {
    top: 350px;
}
#linhaDirAppEmp6 {
    top: 400px;
}

/* CSS do ECOLOGIA EMPILHADEIRAS **********************************/
.paiEcoEmp {
    position: relative;
    height: 700px;
    width: 100%;
    background: #2e2d2c;
    overflow: hidden;
}
.backgroundEcoEmp {
    width: 100%;
    height: 100%;
}
.FullCardEmp {
    width: 100%;
    height: 700px;
}
.frontendEcoEmp {
    width: 100%;
}
.subTituloEcoEmp1 {
    position: absolute;
    font-size: 3em;
    font-family: 'Raleway';
    line-height: 1.1;
    color: #eee;
    top: 200px;
    left: 100px;
}
.subTituloEcoEmp2 {
    position: absolute;
    font-size: 2em;
    font-family: 'Raleway';
    line-height: 1.1;
    color: #eee;
    top: 400px;
    text-align: right;
    left: calc(100% - 500px);
}
.iconeEcoEmp1 {
    position: absolute;
    font-size: 4.5em;
    color: #fff;
    top: 70px;
    left: 100px;
}
.textoEcoEmp2 {
    position: absolute;
    font-size: 1.3em;
    font-family:'Raleway';
    /*font-weight:lighter;*/
    color: #eee;
    top: 120px;
    left: calc(100% - 500px);
    text-align: right;
} 
.textoEcoEmp1 {
    position: absolute;
    font-size: 1.3em;
    font-family:'Raleway';
    /*font-weight:lighter;*/
    color: #eee;
    top: 400px;
    left: 100px;
}             
               
/* Inicio CSS VERSUS Baterias****************/
.paiVsEmp {
    position: relative;
    height: 800px;
    width: 100%;
    background: #eee;
    overflow: hidden;
}
.frontendVsEmp {
    width: 100%;
}
.tituloVsEmp1 {
    position: absolute;
    font-size: 2.5em;
    font-family: 'Raleway';
    color: #2e2d2c;
    top: 150px;
    left: calc(50% - 440px);
    text-align:right;
    line-height: 1;
}
.tituloVsEmp2 {
    position: absolute;
    font-size: 2.5em;
    font-family: 'Raleway';
    color: #2e2d2c;
    top: 150px;
    left: calc(50% + 80px);
    text-align:left;
    line-height: 1;
}
.textoVsEmp1 {
    position: absolute;
    font-size: 1.3em;
    font-family:'Raleway';
    font-weight:lighter;
    color: #2e2d2c;
    top: 300px;
    left: calc(50% - 440px);
    text-align:right;
    line-height: 1;
}
.textoVsEmp2 {
    position: absolute;
    font-size: 1.3em;
    font-family:'Raleway';
    font-weight:lighter;
    color: #2e2d2c;
    top: 300px;
    left: calc(50% + 80px);
    text-align:left;
    line-height: 1;
}
.subTituloVsEmp1 {
    position: absolute;
    font-size: 1.5em;
    font-family: 'Raleway';
    line-height: 1;
    color: #2e2d2c;
    top: 550px;
    left: calc(50% - 375px);
    text-align: right;
    font-weight: bold;
}
.subTituloVsEmp2 {
    position: absolute;
    font-size: 1.5em;
    font-family: 'Raleway';
    line-height: 1;
    color: #2e2d2c;
    top: 550px;
    left:calc(50% + 80px);
    font-weight: bold;
    text-align: left;
}
.iconeVsEmp1 {
    position: absolute;
    font-size: 3.5em;
    color: #2e2d2c;
    top: 140px;
    left:calc(50% - 50px);
    width: 70px;
    height: 70px;
}
.iconeVsEmp2 {
    position: absolute;
    font-size: 3.5em;
    color: #008fac;
    top: 530px;
    left:calc(50% - 35px);
}
.faixaVsEmp1 {
    position: absolute;
    width: 120px;
    height: 40px;
    top: 580px;
    left: calc(50% - 220px);
    background-color: #ffd618;
    border-radius: 15px;
}
.faixaVsEmp2 {
    position: absolute;
    width: 170px;
    height: 40px;
    top: 580px;
    left: calc(50% + 90px);
    background-color: #ffd618;
    border-radius: 15px;
}
.textofaixaVsEmp1 {
    position: absolute;
    font-size: 1.5em;
    font-family: 'Raleway';
    font-weight:bold;
    color: #2e2d2c;
    top: 2px;
    left: 10px;
}
.textofaixaVsEmp2 {
    position: absolute;
    font-size: 1.5em;
    font-family: 'Raleway';
    font-weight:bold;
    color: #2e2d2c;
    top: 2px;
    left: 10px;
} 


/* MEDIA QUERY LG ****************************************************************/
@media (min-width: 992px) and (max-width:1199px) { /* LG */

/* Inicio CSS VANTAGENS Empilhadeiras ****************/
.tituloVantagensEmp {
    font-size: 3.5em;
    top: 130px;
    left: 100px;
}
.textoVantagensEmp {
    font-size: 1.1em;
    top: 400px;
    left: calc(50% + 50px);
}
.subTituloVantagensEmp1 {
    font-size: 2em;
    top: 330px;
    left: 150px;
}
.subTituloVantagensEmp2 {
    font-size: 2em;
    top: 250px;
    left: calc(50% + 50px);
}
.iconeVantagensEmp1 {
    font-size: 3.5em;
    top: 320px;
    left: 70px;
}
.iconeVantagensEmp2 {
    font-size: 3.5em;
    top: 250px;
    left: calc(50% - 20px);
}

/* CSS do ECOLOGIA EMPILHADEIRAS **********************************/
.subTituloEcoEmp1 {
    font-size: 2.2em;
    top: 250px;
    left: 70px;
}
.subTituloEcoEmp2 {
    font-size: 1.5em;
    top: 310px;
    left: calc(100% - 420px);
}
.iconeEcoEmp1 {
    font-size: 4em;
    top: 120px;
    left: 70px;
}
.textoEcoEmp2 {
    font-size: 1.2em;
    top: 80px;
    left: calc(100% - 470px);
} 
.textoEcoEmp1 {
    font-size: 1.2em;
    top: 450px;
    left: 70px;
}

/* Inicio CSS VERSUS Baterias****************/

.tituloVsEmp1 {
    font-size: 2.3em;
    top: 150px;
    left: calc(50% - 350px);
}
.tituloVsEmp2 {
    font-size: 2.3em;
    top: 150px;
    left: calc(50% + 25px);
}
.textoVsEmp1 {
    font-size: 1.1em;
    top: 300px;
    left: calc(50% - 350px);
}
.textoVsEmp2 {
    font-size: 1.1em;
    top: 300px;
    left: calc(50% + 25px);
}
.subTituloVsEmp1 {
    font-size: 1.3em;
    top: 550px;
    left: calc(50% - 300px);
}
.subTituloVsEmp2 {
    font-size: 1.3em;
    top: 550px;
    left:calc(50% + 25px);
}
.iconeVsEmp1 {
    top: 140px;
    left:calc(50% - 50px);
    width: 70px;
    height: 70px;
}
.iconeVsEmp2 {
    font-size: 3.5em;
    top: 530px;
    left:calc(50% - 35px);
}
.faixaVsEmp1 {
    top: 580px;
    left: calc(50% - 180px);
}
.faixaVsEmp2 {
    top: 580px;
    left: calc(50% + 25px);
}

}


/* MEDIA QUERY MD *********************************************************/
@media (min-width: 768px) and (max-width:991px) { /* MD */

/* Inicio CSS VANTAGENS Empilhadeiras ****************/


.tituloVantagensEmp {
    font-size: 3.5em;
    top: 100px;
    left: 150px;
}
.textoVantagensEmp {
    font-size: 1.1em;
    top: 410px;
    left: calc(50% - 50px);
}
.subTituloVantagensEmp1 {
    font-size: 2em;
    top: 330px;
    left: 150px;
}
.subTituloVantagensEmp2 {
    font-size: 2em;
    top: 220px;
    left: calc(50% - 50px);
}
.iconeVantagensEmp1 {
    font-size: 3.5em;
    top: 320px;
    left: 70px;
}
.iconeVantagensEmp2 {
    font-size: 3.5em;
    top: 220px;
    left: calc(50% - 120px);
}
.faixaVantagensEmp {
    width: 450px;
    height: 100px;
    top: 630px;
    left: 3px;
}

/* CSS do ECOLOGIA EMPILHADEIRAS **********************************/
.paiEcoEmp {
    height: 960px;
}
.FullCardEmp {
    height: 960px;
}
.subTituloEcoEmp1 {
    font-size: 3em;
    top: 200px;
    left: 100px;
}
.subTituloEcoEmp2 {
    font-size: 2em;
    top: 600px;
    left: calc(100% - 500px);
}
.iconeEcoEmp1 {
    font-size: 5.5em;
    top: 30px;
    left: 100px;
}
.textoEcoEmp2 {
    font-size: 1.2em;
    top: 700px;
    left: calc(100% - 450px);
} 
.textoEcoEmp1 {
    font-size: 1.2em;
    top: 400px;
    left: 100px;
}      

/* CSS do APLICACOES EMPILHADEIRAS **********************************/
.paiAplicacoesEmp {
    height: 2900px;
}

/* Inicio CSS VERSUS Baterias****************/

.tituloVsEmp1 {
    font-size: 2.3em;
    top: 150px;
    left: calc(50% - 350px);
}
.tituloVsEmp2 {
    font-size: 2.3em;
    top: 150px;
    left: calc(50% + 25px);
}
.textoVsEmp1 {
    font-size: 1.1em;
    top: 300px;
    left: calc(50% - 350px);
}
.textoVsEmp2 {
    font-size: 1.1em;
    top: 300px;
    left: calc(50% + 25px);
}
.subTituloVsEmp1 {
    font-size: 1.3em;
    top: 550px;
    left: calc(50% - 300px);
}
.subTituloVsEmp2 {
    font-size: 1.3em;
    top: 550px;
    left:calc(50% + 25px);
}
.iconeVsEmp1 {
    top: 140px;
    left:calc(50% - 50px);
    width: 70px;
    height: 70px;
}
.iconeVsEmp2 {
    font-size: 3.5em;
    top: 530px;
    left:calc(50% - 35px);
}
.faixaVsEmp1 {
    top: 580px;
    left: calc(50% - 180px);
}
.faixaVsEmp2 {
    top: 580px;
    left: calc(50% + 25px);
}


}


/* MEDIA QUERY SM *************************************************************/
@media (min-width: 576px) and (max-width:767px) { /* SM */

/* Inicio CSS VANTAGENS Empilhadeiras ****************/
.tituloVantagensEmp {
    font-size: 3.5em;
    top: 100px;
    left: 150px;
}
.textoVantagensEmp {
    font-size: 1.1em;
    top: 410px;
    left: calc(50% - 50px);
}
.subTituloVantagensEmp1 {
    font-size: 2em;
    top: 330px;
    left: 150px;
}
.subTituloVantagensEmp2 {
    font-size: 2em;
    top: 220px;
    left: calc(50% - 50px);
}
.iconeVantagensEmp1 {
    font-size: 3.5em;
    top: 320px;
    left: 70px;
}
.iconeVantagensEmp2 {
    font-size: 3.5em;
    top: 220px;
    left: calc(50% - 120px);
}
.faixaVantagensEmp {
    width: 450px;
    height: 100px;
    top: 630px;
    left: 3px;
}

/* CSS do APLICACOES EMPILHADEIRAS **********************************/
.paiAplicacoesEmp {
    height: 2300px;
}

/* CSS do ECOLOGIA EMPILHADEIRAS **********************************/
.paiEcoEmp {
    height: 960px;
}
.FullCardEmp {
    height: 960px;
}
.subTituloEcoEmp1 {
    font-size: 2.5em;
    top: 200px;
    left: 50px;
}
.subTituloEcoEmp2 {
    font-size: 2em;
    top: 600px;
    left: calc(100% - 500px);
}
.iconeEcoEmp1 {
    font-size: 5.5em;
    top: 30px;
    left: 100px;
}
.textoEcoEmp2 {
    font-size: 1.2em;
    top: 700px;
    left: calc(100% - 450px);
} 
.textoEcoEmp1 {
    font-size: 1.2em;
    top: 400px;
    left: 50px;
}

/* Inicio CSS VERSUS Baterias****************/

.tituloVsEmp1 {
    font-size: 1.5em;
    top: 170px;
    left: calc(50% - 250px);
}
.tituloVsEmp2 {
    font-size: 1.5em;
    top: 170px;
    left: calc(50% + 25px);
}
.textoVsEmp1 {
    font-size: 1em;
    top: 300px;
    left: calc(50% - 270px);
}
.textoVsEmp2 {
    font-size: 1em;
    top: 300px;
    left: calc(50% + 0px);
}
.subTituloVsEmp1 {
    font-size: 1.2em;
    top: 550px;
    left: calc(50% - 260px);
}
.subTituloVsEmp2 {
    font-size: 1.2em;
    top: 550px;
    left:calc(50% + 10px);
}
.iconeVsEmp1 {
    top: 140px;
    left:calc(50% - 50px);
    width: 70px;
    height: 70px;
}
.iconeVsEmp2 {
    font-size: 3.5em;
    top: 530px;
    left:calc(50% - 35px);
}
.faixaVsEmp1 {
    top: 580px;
    left: calc(50% - 180px);
}
.faixaVsEmp2 {
    top: 580px;
    left: calc(50% + 25px);
}

}


/* MEDIA QUERY XS ****************************************************/
@media (max-width:575px) { /* XS */

/* Inicio CSS VANTAGENS Empilhadeiras ****************/


.tituloVantagensEmp {
    font-size: 3.5em;
    top: 100px;
    left: 100px;
}
.textoVantagensEmp {
    font-size: 1.1em;
    top: 410px;
    left: calc(50% - 130px);
}
.subTituloVantagensEmp1 {
    font-size: 2em;
    top: 330px;
    left: 150px;
}
.subTituloVantagensEmp2 {
    font-size: 2em;
    top: 220px;
    left: calc(50% - 50px);
}
.iconeVantagensEmp1 {
    font-size: 3.5em;
    top: 320px;
    left: 70px;
}
.iconeVantagensEmp2 {
    font-size: 3.5em;
    top: 220px;
    left: calc(50% - 120px);
}
.faixaVantagensEmp {
    width: 450px;
    height: 100px;
    top: 650px;
    left: 3px;
}

/* CSS do APLICACOES EMPILHADEIRAS **********************************/
.paiAplicacoesEmp {
    height: 1800px;
}

/* CSS do ECOLOGIA EMPILHADEIRAS **********************************/
.paiEcoEmp {
    height: 960px;
}
.FullCardEmp {
    height: 960px;
}
.subTituloEcoEmp1 {
    font-size: 2.2em;
    top: 200px;
    left: 50px;
}
.subTituloEcoEmp2 {
    font-size: 2em;
    top: 600px;
    left: calc(100% - 450px);
}
.iconeEcoEmp1 {
    font-size: 5.5em;
    top: 30px;
    left: 70px;
}
.textoEcoEmp2 {
    font-size: 1.2em;
    top: 700px;
    left: calc(100% - 400px);
} 
.textoEcoEmp1 {
    font-size: 1.2em;
    top: 400px;
    left: 50px;
}

/* Inicio CSS VERSUS Baterias****************/
.paiVsEmp {
    height: 1200px;
}
.tituloVsEmp1 {
    font-size: 2.5em;
    top: 100px;
    left: 80px;
    text-align:center;
}
.tituloVsEmp2 {
    font-size: 2.5em;
    top: 680px;
    left: 80px;
    text-align:center;
}
.textoVsEmp1 {
    font-size: 1.5em;
    top: 220px;
    left: 50px;
    text-align: center;
}
.textoVsEmp2 {
    font-size: 1.5em;
    top: 800px;
    left: 20px;
    text-align: center;
}
.subTituloVsEmp1 {
    font-size: 1.8em;
    top: 450px;
    left: 80px;
    text-align: center;
}
.subTituloVsEmp2 {
    font-size: 1.8em;
    top: 1050px;
    left: 80px;
    text-align: center;
}
.iconeVsEmp1 {
    top: 570px;
    left: 230px;
    width: 70px;
    height: 70px;
}
.iconeVsEmp2 {
    display:none;
}
.faixaVsEmp1 {
    top: 500px;
    left: 200px;
}
.faixaVsEmp2 {
    top: 1100px;
    left: 170px;
}


}

</style>